import { FormGroup, Label, Input, Button } from "reactstrap";
import LinkPreview from "../LinkPreview/LinkPreview";

const Step3 = (props) => {
  if (props.currentStep !== 3) {
    return null;
  }

  return (
    <>
      <p className="centerr">
        <h4>{props.stepTitle}</h4>
      </p>
      <div className="centerr">
        <LinkPreview
          hoverBgColor={props.hoverBgColor}
          bgColor={props.bgColor}
          fontColor={props.fontColor}
          borderStyle={props.borderStyle}
          hoverFontColor={props.hoverFontColor}
          name="Exemplo"
          Link="site.com"
        />
      </div>
      <FormGroup>
        <Label className="mt-4" for="bg-color">
          Cor do plano de fundo:
        </Label>
        <Input
          type="color"
          name="bgColor"
          id="bg-color"
          value={props.bgColor}
          onChange={props.handleLinkStyleChange}
        />
        <Label className="mt-4" for="font-color">
          Cor do plano de fundo ao passar ao passar o mouse:
        </Label>
        <Input
          type="color"
          name="hoverBgColor"
          id="font-color"
          value={props.hoverColor}
          onChange={props.handleLinkStyleChange}
        />
        <Label className="mt-4" for="font-color">
          Cor do texto:
        </Label>
        <Input
          type="color"
          name="fontColor"
          id="font-color"
          value={props.fontColor}
          onChange={props.handleLinkStyleChange}
        />
        <Label className="mt-4" for="font-color">
          Cor do texto ao passar o mouse:
        </Label>
        <Input
          type="color"
          name="hoverFontColor"
          id="font-color"
          value={props.hoverFontColor}
          onChange={props.handleLinkStyleChange}
        />
      </FormGroup>
      <FormGroup>
        <Label for="exampleSelect">Estilo das bordas:</Label> <br />
        <div className="centerr">
          <select
            value={props.borderStyle}
            name="borderStyle"
            onChange={props.handleLinkStyleChange}
            style={{ width: "30%" }}
          >
            <option
              style={{ textAlign: "center" }}
              name="borderStyle"
              value="30px"
            >
              Redonda
            </option>
            <option
              style={{ textAlign: "center" }}
              name="borderStyle"
              value="15px"
            >
              Quadrada
            </option>
          </select>
        </div>
      </FormGroup>
      {props.isEditing && (
        <div className="centerr">
          <Button onClick={props.update} className="mt-4">
            Atualizar
          </Button>
        </div>
      )}
    </>
  );
};

export default Step3;
